var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSaveListIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.664 14.5v-1.333c0-1.257 0-1.886-.39-2.277-.391-.39-1.02-.39-2.277-.39h-.666c-1.257 0-1.886 0-2.276.39-.39.391-.39 1.02-.39 2.277V14.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M4.664 5.836h3.333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M2 6.5c0-1.886 0-2.828.586-3.414S4.114 2.5 6 2.5h4.781c.272 0 .409 0 .531.05s.22.148.412.34l1.886 1.886c.192.193.289.29.34.412.05.122.05.258.05.531V10.5c0 1.886 0 2.828-.586 3.414S11.886 14.5 10 14.5H6c-1.886 0-2.828 0-3.414-.586S2 12.386 2 10.5z"
  })));
};
export default SvgSaveListIcon;